import createCache from '@emotion/cache'
import { prefixer } from 'stylis'
import rtlPlugin from 'stylis-plugin-rtl'

/**
 * Emotion cache that runs the stylis RTL plugin so physical CSS emitted by MUI
 * and app components (left/right, margin/padding sides, borders, float,
 * transform translateX, …) is mirrored for right-to-left languages (ar, ar-SA).
 *
 * Only the RTL branch uses this cache; left-to-right rendering keeps MUI's
 * default emotion cache (key `css`), so LTR output is unchanged. The distinct
 * `muirtl` key means the mirrored rules get their own class names and never
 * collide with the LTR ones when the user switches language at runtime.
 */
// `prepend: true` mirrors MUI's default emotion cache so injection order — and
// therefore override/specificity behaviour — is identical between LTR and RTL.
export const cacheRtl = createCache({ key: 'muirtl', prepend: true, stylisPlugins: [prefixer, rtlPlugin] })
